var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayingMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Cd-Player-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Cd Player 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.43 14.5a0.27 0.27 0 0 0 0.22 -0.12A9.35 9.35 0 0 0 20 10.24a0.25 0.25 0 0 0 -0.1 -0.23 0.23 0.23 0 0 0 -0.24 0l-0.86 0.35 -0.08 0.05A3.24 3.24 0 0 1 13.25 8a3.27 3.27 0 0 1 1.86 -2.94 0.26 0.26 0 0 0 0.14 -0.22V3.08a3.26 3.26 0 0 1 0.3 -1.36 0.25 0.25 0 0 0 -0.1 -0.32A9.39 9.39 0 0 0 10.5 0a9.49 9.49 0 0 0 -8.11 14.44 0.11 0.11 0 0 0 0.11 0.06Zm-7.93 -3a2 2 0 1 1 2 -2 2 2 0 0 1 -2 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16h-19A2.5 2.5 0 0 0 0 18.5v2A2.5 2.5 0 0 0 2.29 23a0.25 0.25 0 0 1 0.23 0.2 1 1 0 0 0 2 0 0.25 0.25 0 0 1 0.25 -0.2h14.5a0.25 0.25 0 0 1 0.25 0.2 1 1 0 0 0 2 0 0.25 0.25 0 0 1 0.23 -0.2A2.5 2.5 0 0 0 24 20.5v-2a2.5 2.5 0 0 0 -2.5 -2.5ZM4 21a0.5 0.5 0 0 1 -0.5 -0.5v-2A0.51 0.51 0 0 1 4 18h10a0.51 0.51 0 0 1 0.5 0.5v2a0.5 0.5 0 0 1 -0.5 0.5Zm16.5 -3a1 1 0 1 1 -1 1 1 1 0 0 1 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.06 1.17a2 2 0 0 0 -1.56 2v3a0.26 0.26 0 0 1 -0.19 0.24 1.75 1.75 0 1 0 2.19 1.7v-4.8a0.25 0.25 0 0 1 0.18 -0.24l3 -1a0.25 0.25 0 0 1 0.33 0.24v1.8a0.26 0.26 0 0 1 -0.19 0.24A1.75 1.75 0 1 0 24 6.05V2a2 2 0 0 0 -2.37 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayingMusic);
export default ForwardRef;